import './FeedbackButton.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useBoundAction } from 'src/hooks/useBoundAction';
import { Button } from 'src/modules/common/components/Button';
import { Modal } from 'src/modules/common/components/Modal';
import { MailIcon } from 'src/modules/common/icons/MailIcon';
import { FEEDBACK_OPEN } from 'src/modules/feedback/actions/FeedbackActions';
import { getFeedbackModal } from 'src/modules/feedback/selectors/getFeedbackModal';
import { FeedbackModal } from 'src/modules/feedback/views/FeedbackModal';

export const FeedbackButton = (): React.ReactElement => {
  const handleOpen = useBoundAction(FEEDBACK_OPEN.trigger, true);
  const handleClose = useBoundAction(FEEDBACK_OPEN.trigger, false);

  const feedbackModalOpened = useSelector(getFeedbackModal);

  return (
    <>
      <div className="bp-feedback-button">
        <Button
          className="bp-feedback-button__button"
          kind="secondary"
          size="sm"
          onClick={handleOpen}
        >
          <div className="bp-feedback-button__button-icon">
            <MailIcon/>
          </div>

          <FormattedMessage id="feedback/button"/>
        </Button>
      </div>

      <Modal
        className="bp-feedback-modal"
        opened={feedbackModalOpened}
        handleClose={handleClose}
        size="md"
      >
        <FeedbackModal onClose={handleClose}/>
      </Modal>
    </>
  );
};
